<script>
	import Navigation from '@/components/Navigation/Navigation'
	import BottomFooter from '@/components/BottomFooter/BottomFooter'

	import 'normalize.css'
	import './styles/style.scss'

	export default {
		name: 'app',
		methods: {
			showNav () {
				const noNavRoutes = [
					'/subscribe',
					'/solution',
				]
				const currentRoute = this.$router.currentRoute.path;
				return noNavRoutes.some((key, value) => {
					return key === currentRoute;
				})
			}
		},
		components: {
			Navigation,
			BottomFooter,
		},
	}

</script>

<template>
	<div id='app' class='app'>
		<div v-bind:class="{ 'app-container': true, 'no-nav': showNav() }">
			<Navigation />
			<router-view />
			<BottomFooter />
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/containers/App/App.vue